import { motion } from "motion/react";
import { safeUrl } from "../lib/safeUrl.js";
import { MOTION_TIMING, editorialEase } from "../motion/choreography.js";

export default function ContactFinale({ data, disclosure, name }) {
  const href = safeUrl(data.href);

  return (
    <footer id="contact" className="contact" aria-labelledby="contact-title">
      <div className="section-kicker section-kicker--orange">
        <span>05 / Contact</span>
        <span>Open for selected collaborations</span>
      </div>
      <motion.h2
        id="contact-title"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.35 }}
        variants={{
          hidden: {},
          visible: { transition: { staggerChildren: MOTION_TIMING.heroStagger } }
        }}
      >
        {data.headline.map((word, index) => (
          <motion.span
            key={word}
            variants={{
              hidden: { x: index === 1 ? "18%" : "-18%", opacity: 0 },
              visible: {
                x: 0,
                opacity: 1,
                transition: { duration: 0.82, ease: editorialEase }
              }
            }}
          >
            {word}
          </motion.span>
        ))}
      </motion.h2>
      <div className="contact__meta">
        <div>
          <span>{name}</span>
          <span>{data.availability}</span>
        </div>
        {href && <a href={href}>{data.email}<b aria-hidden="true">↗</b></a>}
      </div>
      <motion.div
        className="contact__sun"
        aria-hidden="true"
        initial={{ scale: 0.45, rotate: -35 }}
        whileInView={{ scale: 1, rotate: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 1.1, ease: editorialEase }}
      />
      <p className="contact__disclosure">{disclosure}</p>
    </footer>
  );
}
